<template>
  <SidebarWidget>
    <template v-slot:title>
      {{ $t('bulkSend.whatsABulkSend') }}
    </template>
    <template v-slot:content>
      <p>{{ $t('bulkSend.notSureWhatThisDoes') }}</p>
      <img
        src="@/assets/bulk-send-help-video.png"
        :alt="$t('bulkSend.bulkSendHelpVideo')"
        class="shadow-widgetImage"
      >
    </template>
    <template v-slot:cta>
      <BaseLink
        class="w-full"
        variant="secondary"
        size="large"
        href="https://signable.help/whats-a-bulk-send/"
        target="_blank"
        data-ec="bulk_send_what_is_widget"
        data-et="watch_the_video_button"
      >
        {{ $t('bulkSend.watchTheVideo') }}
      </BaseLink>
    </template>
  </SidebarWidget>
</template>

<script>
import SidebarWidget from '@/components/library/widgets/SidebarWidget.vue';
import BaseLink from '@/components/library/links/BaseLink.vue';

export default {
  name: 'WhatIsBulkSendWidget',
  components: { BaseLink, SidebarWidget },
};
</script>

<style scoped>

</style>
